<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>
  <app-banner [pageData]="pageData" *ngIf="pageData.carousel"></app-banner>
  <section class="tsandcs-page">
    <div class="header-background"></div>
    <div class="content-wrapper pos-rel-md">
      <h1 *ngIf="pageData.title">{{ pageData.title }}</h1>
      <div class="separator"></div>
      <app-page-retrieval-error
        *ngIf="pageRetrievalError"
      ></app-page-retrieval-error>
      <div class="privacy-policies-container content" *ngIf="pageData.policies">
        <div class="privacy-policy" *ngFor="let policy of pageData.policies">
          <h5 class="policy-heading">
            {{ policy.policy_title }}
          </h5>
          <div class="privacy-policy-content">
            <app-render-markdown
              [content]="policy.policy_content!"
            ></app-render-markdown>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
